import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MongoResource } from 'app/shared/mongo.resource';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';

// @Injectable()
// export class AnnouncementsService {

//     constructor() { }

// }

@Injectable()
export class AnnouncementsService extends MongoResource<any, IAnnouncement, IAnnouncement> {
  baseUrl = environment.api + 'announcements';
  constructor(public http: HttpClient) {
    super(http);
  }

  getAllRoutes(): Observable<any[]> {
    return this.$get('routes');
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/announcements/shared/announcements.service.ts